import React from 'react';
import { Button, Form, Input, Segment, TextArea, Grid } from 'semantic-ui-react';
import { DateTimePicker } from 'react-widgets';
import axios from 'axios';
import { toast } from 'react-toastify';


export default class AddNewStudentMobilityInternship extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            institution: '',
            institutionEn: '',
            institutionOther: '',
            startDate: new Date(),
            endDate: new Date(),
            description: '',
            comment: '',
            otherLang: '',
            otherLangOptions: [],
            mob: JSON.parse(localStorage.getItem('mob')),

            institutionErr: false,
            institutionEnErr: false,
            institutionOtherErr: false,
            startDateErr: false,
            endDateErr: false,
            descriptionErr: false,
            commentErr: false,
            otherLangErr: false

        };
        this.closeAddMode = this.closeAddMode.bind(this);
        this.handleDateChange = this.handleDateChange.bind(this);
        this.handleInputChange = this.handleInputChange.bind(this);
        this.fetchLangOptions = this.fetchLangOptions.bind(this);
        this.resetForm = this.resetForm.bind(this);
        this.addIntership = this.addIntership.bind(this);
    }

    componentDidMount() {
        this.fetchLangOptions();
    }

    fetchLangOptions() {
        axios.get('/languages')
            .then(res => {
                this.setState({
                    otherLangOptions: res.data.map(el => ({
                        key: el.id,
                        value: el.twoLetterCode,
                        text: el.name
                    })),
                    otherLang: this.state.mob.translations.filter((e) => e.originalLanguage === true)[0].language
                    // otherLang: this.state.mob.country.officialLanguage.twoLetterCode
                });
            });
    }
    closeAddMode() {
        this.props.closeAddMode();
    }

    handleInputChange(event, { name, value }) {
        this.setState({
            [name]: value
        });
    }
    handleDateChange(name, date) {
        this.setState({
            [name]: date
        });
    }

    resetForm() {
        this.setState({

            institution: null,
            institutionOther: null,
            startDate: null,
            endDate: null,
            description: null,
            comment: null,
            otherLang: null,

        });
    }

    addIntership() {
        if (!this.state.institution || !this.state.startDate || !this.state.endDate ||
            (!this.state.institutionEn && !this.state.institutionOther && !this.state.otherLang)
            || (this.state.institutionEn && this.state.institutionOther && !this.state.otherLang)
            || (!this.state.institutionEn && this.state.institutionOther && !this.state.otherLang)
            || (!this.state.institutionEn && !this.state.institutionOther && this.state.otherLang)) {
            if (!this.state.institutionEn && !this.state.institutionOther) {
                toast('Niste unijeli sve podatke. Unesite barem jedan prevod za instituciju.');
            } else { toast('Niste unijeli sve podatke.'); }
            if (!this.state.institution) { this.setState({ institutionErr: true }); } else { this.setState({ institutionErr: false }); }
            if (!this.state.startDate) { this.setState({ startDateErr: true }); } else { this.setState({ startDateErr: false }); }
            if (!this.state.endDate) { this.setState({ endDateErr: true }); } else { this.setState({ endDateErr: false }); }
            if (!this.state.institutionEn && !this.state.institutionOther && !this.state.otherLang) { this.setState({ institutionEnErr: true, institutionOtherErr: true, otherLangErr: true }); } else { this.setState({ institutionEnErr: false, institutionOtherErr: false, otherLangErr: false }); }
            if (!this.state.institutionEn && !this.state.institutionOther && this.state.otherLang) { this.setState({ institutionOtherErr: true, }); }
            if (!this.state.institutionEn && this.state.institutionOther && !this.state.otherLang) { this.setState({ otherLangErr: true }); }
            if (this.state.institutionOther && !this.state.otherLang) { this.setState({ otherLangErr: true }); }
            if (!this.state.institutionOther && this.state.otherLang) { this.setState({ institutionOtherErr: true }); }
        } else {
            this.setState({ loader: true });
            let transaltions = [];
            if (this.state.institutionEn && this.state.otherLang !== 'en') {
                transaltions.push({
                    language: { twoLetterCode: this.state.otherLangOptions.filter((e) => e.value === 'en') ? this.state.otherLangOptions.find((e) => e.value === 'en').value : null },
                    institutionName: this.state.institutionEn
                });
            }
            if (this.state.institutionOther) {
                transaltions.push({
                    language: { twoLetterCode: this.state.otherLang },
                    institutionName: this.state.institutionOther
                });
            }
            let obj = {
                studentStudyProgramMobility: { id: this.state.mob.id },
                institutionName: this.state.institution,
                description: this.state.description,
                dateStart: this.state.startDate,
                dateEnd: this.state.endDate,
                comment: this.state.comment,
                translations: transaltions
            };
            axios.post('/student-mobility-internship/add/', { ...obj }).then((res) => {
                toast('Uspješno ste dodali praksu za studenta!');
                this.setState({ loader: false });
                this.resetForm();
                this.closeAddMode();
                this.props.getMobilityInternship();
            }).catch(() => {
                this.setState({ loader: false });
                toast('Došlo je do greške! Studentu nije unešena praksa.');
            });
        }
    }

    render() {
        return (
            <div>
                <Segment.Group secondary>
                    <Segment secondary clearing>
                        <Form noValidate>
                            <Grid columns={2} centered className="stackable">
                                <Grid.Row stretched>
                                    <Grid.Column>
                                        <Form.Field
                                            required
                                            control={Input}
                                            label="Institucija"
                                            value={this.state.institution}
                                            onChange={(e) => this.setState({ institution: e.target.value })}
                                            name="institution"
                                            placeholder="Unesite naziv institucije"
                                            error={this.state.institutionErr}
                                        />
                                        <Form.Field
                                            control={Input}
                                            label="Institucija (engleski jezik)"
                                            value={this.state.institutionEn}
                                            onChange={(e) => this.setState({ institutionEn: e.target.value })}
                                            name="institutionEn"
                                            placeholder="Unesite naziv institucije"
                                            error={this.state.institutionEnErr}
                                            disabled={this.state.otherLang === 'en'}
                                        />
                                    </Grid.Column>
                                    <Grid.Column>
                                        <Segment>
                                            <Form.Field error={this.state.otherLangErr}>
                                                <label>Izvorni jezik</label>
                                                <Form.Dropdown
                                                    clearable
                                                    selection
                                                    placeholder="Odaberite izvorni jezik"
                                                    value={this.state.otherLang}
                                                    onChange={this.handleInputChange}
                                                    name="otherLang"
                                                    options={this.state.otherLangOptions.filter((e) => (e.value === this.state.mob.translations.filter((e) => e.originalLanguage === true)[0].language))}
                                                    // options={this.state.otherLangOptions.filter((e) => (e.value === this.state.mob.country.officialLanguage.twoLetterCode))}
                                                    // options={this.state.otherLangOptions.filter((e) => (e.value !== 'en' && e.value !== 'bs'))}
                                                    search
                                                    fluid
                                                />
                                            </Form.Field>
                                            <Form.Field
                                                control={Input}
                                                label="Institucija (izvorni jezik)"
                                                value={this.state.institutionOther}
                                                onChange={(e) => this.setState({ institutionOther: e.target.value })}
                                                name="institutionOther"
                                                placeholder="Unesite naziv institucije"
                                                error={this.state.institutionOtherErr}
                                            />
                                        </Segment>
                                    </Grid.Column>
                                </Grid.Row>
                            </Grid>
                            <Grid columns={2} centered className="stackable">
                                <Grid.Row stretched>
                                    <Grid.Column>
                                        <Grid.Column>
                                            <Form.Field
                                                required
                                                control={DateTimePicker}
                                                label="Datum početka"
                                                format="D. M. YYYY."
                                                defaultValue={this.state.startDate}
                                                placeholder="Unesite datum početka prakse"
                                                value={this.state.startDate}
                                                time={false}
                                                onChange={this.handleDateChange.bind(null, 'startDate')}
                                                style={{ borderWidth: '0px' }}
                                                error={this.state.startDateErr}
                                            />
                                        </Grid.Column>
                                        <Grid.Column>
                                            <Form.Field
                                                required
                                                control={DateTimePicker}
                                                label="Datum kraja"
                                                format="D. M. YYYY."
                                                defaultValue={this.state.endDate}
                                                placeholder="Unesite datum kraja prakse"
                                                value={this.state.endDate}
                                                time={false}
                                                onChange={this.handleDateChange.bind(null, 'endDate')}
                                                style={{ borderWidth: '0px' }}
                                                error={this.state.endDateErr}
                                            />
                                        </Grid.Column>
                                    </Grid.Column>
                                    <Grid.Column>
                                        <Form.Field
                                            label="Opis"
                                            control={TextArea}
                                            name="description"
                                            rows={6}
                                            value={this.state.description}
                                            onChange={this.handleInputChange}
                                            placeholder="Unesite opis..."
                                        />
                                    </Grid.Column>
                                </Grid.Row>
                            </Grid>
                            <Grid columns={1} centered className="stackable">
                                <Grid.Row stretched>
                                    <Grid.Column>
                                        <Form.Field
                                            label="Komentar"
                                            control={TextArea}
                                            name="comment"
                                            rows={1}
                                            value={this.state.comment}
                                            onChange={this.handleInputChange}
                                            placeholder="Unesite komentar..."
                                        />
                                    </Grid.Column>
                                </Grid.Row>
                            </Grid>
                            <br />
                            <Button color="blue" basic="true" floated="right" onClick={this.closeAddMode}>Odustani</Button>
                            <Button
                                color="blue"
                                floated="right"
                                onClick={this.addIntership}
                            >
                                Dodaj
                            </Button>
                        </Form>
                    </Segment>
                </Segment.Group>
            </div>
        );
    }
}




// WEBPACK FOOTER //
// ./src/views/StudentService/StudentOverview/AddNewStudentMobilityInternship.js